<template>
	<div>巡诊数据</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>